<app-container-standard title="Stockout">

  <div class="filter-bar">
    <mat-form-field class="filter-field">
      <mat-label>Period</mat-label>
      <mat-select [(value)]="period" (selectionChange)="setPeriod()">
        <mat-option value="TODAY">Today</mat-option>
        <mat-option value="YESTERDAY">Yesterday</mat-option>
        <mat-option value="LAST-7-DAYS">Last 7 days</mat-option>
        <mat-option value="LAST-14-DAYS">Last 14 days</mat-option>
        <mat-option value="LAST-30-DAYS">Last 30 days</mat-option>
        <mat-option value="THIS_MONTH">This month</mat-option>
        <mat-option value="LAST_MONTH">Last month</mat-option>
        <mat-option value="CUSTOM">Custom range</mat-option>
      </mat-select>
    </mat-form-field>

    @if (period === 'CUSTOM') {
      <mat-form-field class="filter-field range-field">
        <mat-label>Custom range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
          <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    }

    <mat-form-field class="filter-field">
      <mat-label>System</mat-label>
      <mat-select [(value)]="systemFilter" (selectionChange)="applyFilters()">
        <mat-option value="all">All systems</mat-option>
        @for (option of systemOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-field">
      <mat-label>Product</mat-label>
      <mat-select [(value)]="productFilter" (selectionChange)="applyFilters()">
        <mat-option value="all">All products</mat-option>
        @for (option of productOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-field">
      <mat-label>Show</mat-label>
      <mat-select [(value)]="stockFilter" (selectionChange)="applyFilters()">
        <mat-option value="real">Real stockouts</mat-option>
        <mat-option value="stock-left">Stock left (not real)</mat-option>
        <mat-option value="all">All alerts</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-field search-field">
      <mat-label>Search product, system or machine</mat-label>
      <input matInput [(ngModel)]="search" (ngModelChange)="applyFilters()" autocomplete="off">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-button-toggle-group [(value)]="groupBy" (change)="applyFilters()" class="toggle-group">
      <mat-button-toggle value="system">By system</mat-button-toggle>
      <mat-button-toggle value="product">By product</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group [(value)]="view" class="toggle-group">
      <mat-button-toggle value="cards">Cards</mat-button-toggle>
      <mat-button-toggle value="list">List</mat-button-toggle>
    </mat-button-toggle-group>

    <button mat-button (click)="clearFilters()">Clear</button>

    <span class="spacer"></span>

    <button mat-icon-button (click)="exportSummaryAsXLSX()" matTooltip="Export summary to Excel">
      <mat-icon>summarize</mat-icon>
    </button>
    <button mat-icon-button (click)="exportAsXLSX()" matTooltip="Export all events to Excel">
      <i class="fa fa-file-excel-o" style="font-size:24px"></i>
    </button>
  </div>

  <div class="summary-bar">
    <span class="range">{{ rangeLabel }}</span>
    <span class="stat"><strong>{{ totalEvents }}</strong> stockouts</span>
    <span class="stat"><strong>{{ totalProducts }}</strong> products</span>
    <span class="stat"><strong>{{ totalSystems }}</strong> systems</span>
  </div>

  @if (loading) {
    <div class="empty-state">Loading…</div>
  } @else if (filtered.length === 0) {
    <div class="empty-state">No stockouts for the selected period and filters.</div>
  } @else if (view === 'cards') {
    <div class="card-container">
      @for (group of groups; track group.key) {
        <div class="card">
          <div class="card-header">
            <h2>{{ group.key }}</h2>
            <span class="count-badge">{{ group.count }}</span>
          </div>
          <div class="card-body">
            @for (row of group.rows; track row.label) {
              <div class="notification">
                <h3>{{ row.label }}</h3>
                <p class="message">Last: {{ row.lastSeen }}</p>
                <span class="row-count">{{ row.count }}x</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="list-container">
      <table class="stockout-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>System</th>
            <th>Product</th>
            <th>Machine</th>
            <th>Threshold</th>
            <th matTooltip="Product stock in the whole system when the order was placed">Qty before</th>
            <th>Left after</th>
          </tr>
        </thead>
        <tbody>
          @for (n of filtered; track $index) {
            <tr [class.stock-left]="n.stockStatus === 'stock-left'">
              <td>{{ n.createdAt }}</td>
              <td>{{ n.system }}</td>
              <td>{{ n.productName }}</td>
              <td>{{ n.machineCode }}</td>
              <td>{{ n.threshold }}</td>
              <td>{{ n.stockBefore ?? '-' }}</td>
              <td>{{ n.stockLeft ?? '-' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

</app-container-standard>
